var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2834 14.2085H13.2917M8.70833 14.2085H8.71655",
    stroke: "#171615",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91216 17.2743C4.1183 18.8054 5.38646 20.0049 6.92969 20.0758C8.22825 20.1355 9.54736 20.1667 11 20.1667C12.4526 20.1667 13.7717 20.1355 15.0703 20.0758C16.6136 20.0049 17.8817 18.8054 18.0879 17.2743C18.2224 16.2751 18.3333 15.2511 18.3333 14.2083C18.3333 13.1655 18.2224 12.1415 18.0879 11.1424C17.8817 9.61125 16.6136 8.41178 15.0703 8.34083C13.7717 8.28114 12.4526 8.25 11 8.25C9.54736 8.25 8.22825 8.28114 6.92969 8.34083C5.38646 8.41178 4.1183 9.61125 3.91216 11.1424C3.77763 12.1415 3.66667 13.1655 3.66667 14.2083C3.66667 15.2511 3.77763 16.2751 3.91216 17.2743Z",
    stroke: "#171615",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.25016V5.9585C6.875 3.68032 8.72183 1.8335 11 1.8335C13.2782 1.8335 15.125 3.68032 15.125 5.9585V8.25016",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassword);
export default __webpack_public_path__ + "static/media/changepassword.fad8cb4ba56ad1ed3c0cf5a6ccd04125.svg";
export { ForwardRef as ReactComponent };